import { render } from "./details.vue?vue&type=template&id=47ee38af&scoped=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"

import "./details.vue?vue&type=style&index=0&id=47ee38af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47ee38af"

export default script